function common() {
	// show current page on navbar
	(function () {
		var pageName = window.location.pathname.replace("/", "");
		try {
			if ($("#navbar-" + pageName).length > 0) {
				$("#navbar-" + pageName).addClass("current");
			}
		} catch (e) {}
	})();

	// ios touch event
	$(".navbar-right a").on("click touchend", function (e) {
		window.location = e.target.href;
	});

	var clickableLetters = {
		hideTime: 500,
		showTime: 550,
		stayTime: 600,
		unselectedClassName: "clickable-text__letter",
		selectedClassName: "clickable-text__letter--selected",
		activeActionElement: "suspendisse--active",
		inactiveActionElement: "suspendisse",
		selectedTitle: "suspendisse__title",
		selectedSubtitle: "suspendisse__subtitle",
		selectedSubsubtitle: "suspendisse__subsubtitle",
		readyToFade: true,
		clickTime: 0,
		letterCount: 0,
		letterCountMax: $(".clickable-text__letter").length,
		started: false,
		animationComplete: false,
		clicks: 0,
		steps: 0,
		title: function () {
			return $("." + this.selectedTitle);
		},
		subtitle: function () {
			return $("." + this.selectedSubtitle);
		},
		subsubtitle: function () {
			return $("." + this.selectedSubsubtitle);
		},
		selectLetterInterval: (function () {
			setInterval(function () {
				if (clickableLetters.started) {
					if (clickableLetters.clickTime == 0) {
						clickableLetters.showSuspendise();
					} else if (clickableLetters.clickTime == 1) {
						clickableLetters.hideSuspendise();
					}
				}
			}, 600);
		})(),
		hideSuspendise: function () {
			clickableLetters.unselectAll();
			this.title()
				.animate(
					{
						opacity: 0
					},
					clickableLetters.hideTime / 6
				)
				.finish(function () {
					clickableLetters.title().css("opacity", "0");
				});

			this.subtitle().animate(
				{
					opacity: 0
				},
				clickableLetters.hideTime / 3,
				function () {
					clickableLetters.subtitle().css("opacity", "0");
				}
			);

			this.subsubtitle().animate(
				{
					opacity: 0
				},
				clickableLetters.hideTime / 2,
				function () {
					clickableLetters.subsubtitle().css("opacity", "0");
				}
			);
		},

		showSuspendise: function () {
			setTimeout(function () {
				clickableLetters
					.title()
					.animate(
						{
							opacity: 1
						},
						clickableLetters.showTime / 5
					)
					.finish(function () {
						clickableLetters.title().css("opacity", "1");
					});
				clickableLetters.subtitle().animate(
					{
						opacity: 1
					},
					clickableLetters.showTime / 3,
					function () {
						clickableLetters.subtitle().css("opacity", "1");
					}
				);
				clickableLetters.subsubtitle().animate(
					{
						opacity: 1
					},
					clickableLetters.showTime / 2,
					function () {
						clickableLetters.subsubtitle().css("opacity", "1");
					}
				);
			}, 50);
		},

		unselectAll: function () {
			$("." + this.selectedClassName).removeClass(this.selectedClassName);
		},
		select: function (target) {
			clickableLetters.started = true;
			clickableLetters.unselectAll();
			clickableLetters.steps++;
			if (clickableLetters.letterCount < 5) {
				clickableLetters.letterCount = parseInt($(target).attr("data-index"));
			} else {
				clickableLetters.letterCount = 0;
				clickableLetters.animationComplete = true;
			}

			$(target).addClass(clickableLetters.selectedClassName);

			$("." + clickableLetters.inactiveActionElement)
				.addClass(clickableLetters.activeActionElement)
				.removeClass(clickableLetters.inactiveActionElement);

			$("." + clickableLetters.activeActionElement).animate(
				{
					opacity: 1
				},
				0,
				function () {
					clickableLetters.title().html($(target).find(".data-title").html());

					clickableLetters
						.subtitle()
						.html($(target).find(".data-subtitle").html());

					clickableLetters
						.subsubtitle()
						.html($(target).find(".data-subsubtitle").html());
				}
			);
		},
		autoStart: function () {
			$("." + clickableLetters.unselectedClassName).on(
				"click",
				function (event) {
					if (event.target.className == clickableLetters.unselectedClassName) {
						clickableLetters.hideSuspendise();
						clickableLetters.unselectAll();
						setTimeout(function () {
							clickableLetters.select(event.target);
							setTimeout(function () {
								clickableLetters.showSuspendise();
							}, clickableLetters.stayTime / 2);
						}, clickableLetters.hideTime / 2);

						clickableLetters.clickTime = 0;
					}

					clickableLetters.clicks++;
					if (clickableLetters.clicks > 1) {
						clickableLetters.animationComplete = true;
						clickableLetters.started = false;
					}
				}
			);

			setInterval(function () {
				if (clickableLetters.started && clickableLetters.clicks == 1) {
					if (clickableLetters.animationComplete) {
						if (clickableLetters.steps == 5) {
							clickableLetters.steps++;

							setTimeout(function () {
								var letter = $(".clickable-text__letter").eq(1);

								clickableLetters.clickTime = 0;

								setTimeout(function () {
									clickableLetters.select(letter);
								}, clickableLetters.stayTime / 2);

								setTimeout(function () {
									clickableLetters.hideSuspendise();
								}, clickableLetters.hideTime / 2);
							}, clickableLetters.stayTime);
						}
					} else {
						if (clickableLetters.letterCount == NaN) {
							clickableLetters.letterCount = 1;
						}
						if (clickableLetters.clickTime == 1) {
							if (
								clickableLetters.letterCount <
								clickableLetters.letterCountMax - 1
							) {
								clickableLetters.letterCount++;
							} else {
								clickableLetters.letterCount = 1;
							}

							var letter = $(".clickable-text__letter").eq(
								clickableLetters.letterCount
							);

							clickableLetters.clickTime = 0;
							setTimeout(function () {
								clickableLetters.select(letter);
							}, clickableLetters.stayTime / 2);
						} else {
							clickableLetters.clickTime++;
						}
					}
				}
			}, clickableLetters.stayTime);
		}
	};

	/*
	 * tips and tricks progressbars
	 */
	var circleProgressBar = {
		add: function (elementClassName, maxVal) {
			var element = "." + elementClassName;
			if ($(element).length > 0) {
				var bar = new ProgressBar.Circle(element, {
					color: "#aaa",
					strokeWidth: 4,
					trailWidth: 1,
					easing: "easeInOut",
					duration: 1400,
					svgStyle: {
						transform: "rotate(120deg)"
					},
					text: {
						autoStyleContainer: false
					},
					from: { color: "#5F259F", width: 2 },
					to: { color: "#5F259F", width: 2 },
					step: function (state, circle) {
						circle.path.setAttribute("stroke", state.color);
						circle.path.setAttribute("stroke-width", state.width);

						var value = Math.round(circle.value() * 100);
						var letter = $(element)
							.siblings(".loader__value")
							.find(".loader__value-letter-container .loader__value-letter");

						var firstNumber = Math.floor(value / 10);
						var secondNumber = value % 10;

						letter[0].innerText = firstNumber;
						letter[1].innerText = secondNumber;
					}
				});

				var allowScrollListener = true;

				$(document).on("scroll mouseenter", function () {
					if (allowScrollListener) {
						var elementPosition = $(element).offset().top;
						allowScrollListener = false;

						setTimeout(function () {
							if (currentPosition() > elementPosition + windowHeight() / 10) {
								bar.animate(maxVal / 100);
							}
							allowScrollListener = true;
						}, 50);
					}
				});
			}
		}
	};

	circleProgressBar.add("loader--7", 7);
	circleProgressBar.add("loader--21", 21);
	circleProgressBar.add("loader--26", 26);
	circleProgressBar.add("loader--50", 50);
	circleProgressBar.add("loader--56", 56);
	circleProgressBar.add("loader--74", 74);
	circleProgressBar.add("loader--90", 90);
	circleProgressBar.add("loader--94", 94);

	var mobileLoginBar = {
		init: (function () {
			var allowScrollListener = true;
			var isLoginPage =
				window.location.href.toLowerCase().indexOf("/loginpage") > -1 ||
				window.location.href.toLowerCase().indexOf("/userregistration") > -1;
			var elementPosition = $(".header-mobile-login");
			$(document).on("scroll mouseenter", function () {
				if (!isLoginPage && $(document).width() < 966) {
					if (allowScrollListener) {
						allowScrollListener = false;

						setTimeout(function () {
							if (currentPosition() > documentHeight() - 150) {
								elementPosition.fadeOut(300);
							} else {
								elementPosition.fadeIn(300);
							}
							allowScrollListener = true;
						}, 50);
					}
				}
			});
		})()
	};

	var input = {
		eventHandlerLabel: $(".input__label"),
		className: "input",
		correctClass: "correct",
		eye: $(".input-password-eye"),
		strong: $(".input-password-strong")
	};

	if (input.eventHandlerLabel.length > 0) {
		input.eventHandlerLabel.on("click", function () {
			var labelIsFor = $(this).attr("for");
			!!$('[name="' + labelIsFor + '"]').val()
				? $('[name="' + labelIsFor + '"]').focus()
				: $('[id="' + labelIsFor + '"]').focus();
		});
	}

	function currentPosition() {
		return $(document).scrollTop() + windowHeight();
	}

	function documentHeight() {
		return $(document).height();
	}

	function windowHeight() {
		return $(window).height();
	}

	var benefits = {
		fixedImage: {
			select: $(".fixed-image"),
			unFix: function () {
				$(this.select).addClass("unfixed");
			},
			fix: function () {
				$(this.select).removeClass("unfixed");
			},
			bottomHeight: function () {
				var footerDistance = $(".footer").height();
				var doubleDistance = $(".double").height();
				return footerDistance + doubleDistance;
			},
			bottomPosition: function () {
				return documentHeight() - this.bottomHeight();
			}
		},
		allowEventListener: true,
		pointText: {
			duration: 5000,
			current: 1,
			all: [
				$(".fixed-image__point-text--1"),
				$(".fixed-image__point-text--2"),
				$(".fixed-image__point-text--3")
			],
			hideAll: function () {
				$.each(this.all, function (i, v) {
					v.hide();
				});
			},
			showText: function (number) {
				this.all[number].show();
			},
			init: function () {
				var current = benefits.pointText.current,
					duration = benefits.pointText.duration,
					all = benefits.pointText.all;
				var benefitsTextChange = setInterval(function () {
					benefits.pointText.hideAll();
					benefits.pointText.showText(current);
					current < all.length - 1 ? current++ : (current = 0);
				}, this.duration);
			}
		}
	};

	function visibilityAction(element, index, action, offset, repeat) {
		element = element || undefined;
		index = index || 0;
		action = action || undefined;
		offset == undefined ? (offset = 6) : (offset = 100 / offset);
		repeat == undefined ? (repeat = true) : false;

		if (
			action != undefined &&
			action != "clickAction" &&
			$("." + element).eq(index).length > 0
		) {
			var allowEventListener = true;

			var element = $("." + element).eq(index);
			var elementPosition = element.offset().top;

			$(document).on("scroll", function () {
				if (allowEventListener) {
					allowEventListener = false;

					setTimeout(function () {
						if (currentPosition() > elementPosition + windowHeight() / 6) {
							$(element).addClass(action);
						} else {
							if (repeat) {
								$(element).removeClass(action);
							}
						}
						allowEventListener = true;
					}, 50);
				}
			});
		} else if (
			action == "clickAction" &&
			$("." + element).eq(index).length > 0
		) {
			var allowActionEventListener = true;

			var element = $("." + element).eq(index);
			var elementPosition = element.offset().top;

			$(document).on("scroll", function () {
				if (allowActionEventListener) {
					setTimeout(function () {
						if (currentPosition() > elementPosition + windowHeight() / 6) {
							if (element.hasClass(clickableLetters.unselectedClassName)) {
								clickableLetters.clicks == 0 ? $(element).click() : false;
							} else {
								$(element).click();
							}
							allowActionEventListener = false;
						}
					}, 50);
				}
			});
		}
	}

	// Pricing calculator
	(function () {
		$("body").attr("id") == "pricing-page" &&
			(function () {
				/*	__|____ f ____ f ____
				 *	q | f[0][0]  f[0][1]
				 * 	q | f[1][0]  f[1][1]
				 *	q | f[2][0]  f[2][1]
				 */
				var packages = {
					quantity: [],
					filters: []
				};

				var tmpPackages = {
					quantity: [
						1000,
						3000,
						5000,
						10000,
						15000,
						25000,
						50000,
						100000,
						200000,
						500000,
						1000000,
						2500000,
						5000000,
						7000000
					],
					filters: [
						[0.009, 0.01133, 0.01287, 0.01437, 0.01601, 0.01746, 0.01908],
						[0.009, 0.01133, 0.01287, 0.01437, 0.01601, 0.01746, 0.01908],
						[0.009, 0.011, 0.01287, 0.0147, 0.01666, 0.01843, 0.02037],
						[0.0085, 0.0099, 0.01178, 0.01362, 0.01558, 0.01736, 0.0193],
						[0.008, 0.00967, 0.01129, 0.01287, 0.01457, 0.0161, 0.01778],
						[0.00752, 0.009, 0.01049, 0.01196, 0.01352, 0.01494, 0.01649],
						[0.00676, 0.0082, 0.0096, 0.01098, 0.01245, 0.01377, 0.01523],
						[0.006, 0.00729, 0.0085, 0.00969, 0.01097, 0.01212, 0.01338],
						[0.00525, 0.00635, 0.00737, 0.00837, 0.00945, 0.01042, 0.01149],
						[0.0045, 0.0055, 0.00643, 0.00735, 0.00833, 0.00921, 0.01018],
						[0.00375, 0.0046, 0.00539, 0.00617, 0.00701, 0.00776, 0.00858],
						[0.00346, 0.00419, 0.00491, 0.00554, 0.00623, 0.00675, 0.0074],
						[0.00334, 0.00404, 0.00474, 0.00534, 0.00601, 0.00651, 0.00715],
						[0.0031, 0.00375, 0.0044, 0.00496, 0.00558, 0.00605, 0.00663]
					]
				};

				function useTmpPricing() {
					packages = tmpPackages;
				}

				var getPricesURL =
					window.location.hostname == "localhost"
						? "https://tasil-stg.tuatara.pl/api/payment/configuration"
						: "/api/payment/configuration";

				$.ajax({
					method: "GET",
					url: getPricesURL
				})
					.done(function (msg) {
						try {
							$.each(msg, function (byFiltersIndex, byFiltersValue) {
								// skip adding next range if it is fixedPrice
								var skipNextSmsQuantityRange = false;
								var currentSmsQuantityRange = 0;
								var smsQuantityRangeAndFiltersPrices = [];
								// all sms quantity ranges
								$.each(
									byFiltersValue,
									function (smsQuantityRangeIndex, smsQuantityRangeValue) {
										!!smsQuantityRangeValue.pricePerSms &&
											(function () {
												smsQuantityRangeAndFiltersPrices.push(
													smsQuantityRangeValue.pricePerSms
												);
											})();

										if (skipNextSmsQuantityRange) {
											skipNextSmsQuantityRange = false;
										} else {
											!!smsQuantityRangeValue.fixedPrice &&
												(function () {
													skipNextSmsQuantityRange = true;
												})();

											packages.quantity[currentSmsQuantityRange] = parseInt(
												smsQuantityRangeIndex
											);
											currentSmsQuantityRange++;
										}
									}
								);
								packages.filters.push(smsQuantityRangeAndFiltersPrices);
							});
							// flip filters arr
							(function () {
								var tmpFiltersArray = [];
								$.each(
									packages.filters,
									function (verticalIndex, verticalValue) {
										var verticalCounter = 0;
										$.each(
											verticalValue,
											function (horizontalIndex, horizontalValue) {
												!!!tmpFiltersArray[verticalCounter] &&
													tmpFiltersArray.push([]);
												tmpFiltersArray[verticalCounter].push(horizontalValue);
												verticalCounter++;
											}
										);
									}
								);
								packages.filters = tmpFiltersArray;
							})();
						} catch (e) {
							useTmpPricing();
						}
					})
					.fail(function (jqXHR, textStatus) {
						useTmpPricing();
					});

				var selectionCounter = $("#pricingSelectionCounter"),
					selection = $("#pricingSelection"),
					selectionArrow = $("#pricingCalculatorSelectionArrow"),
					selectionList = $("#pricingSelectionList"),
					quantity = $("#pricingCalculatorQuantity"),
					selectedFilters = 0,
					SMSquantity = 0,
					price = $("#pricingCalculatorPrice");

				function selectionListActive() {
					return selection.hasClass("active");
				}

				function selectionListAction(action) {
					var items = selectionList.find(".selection-list__list-item");
					$.each(items, function (i, v) {
						setTimeout(function () {
							action === "hide" && $(v).addClass("hidden-item");
							action === "show" && $(v).removeClass("hidden-item");
						}, i * 20);
					});
					selection.toggleClass("active");
				}

				function calculatePrice() {
					function quantityPackage() {
						var q = packages.quantity,
							quantityVariants = q.length,
							packageVariant = 0;

						$.each(q, function (i, v) {
							if (i < quantityVariants - 1) {
								if (SMSquantity < q[i]) {
									packageVariant = i - 1 < 0 ? 0 : i - 1;
									return false;
								}
							} else {
								packageVariant = i;
								return false;
							}
						});
						return packageVariant;
					}

					var p = quantityPackage(),
						f = selectedFilters,
						oldPrice = parseFloat(Number(price.text()).toFixed(2)),
						newPrice = parseFloat(
							Number(packages.filters[p][f] * SMSquantity).toFixed(2)
						),
						priceDiff =
							newPrice > oldPrice ? newPrice - oldPrice : oldPrice - newPrice,
						countedPrice = oldPrice,
						counting = 0;

					var countingInterval = setInterval(function () {
						if (newPrice != oldPrice) {
							if (counting < 10) {
								counting++;
								if (newPrice != 0) {
									newPrice > oldPrice
										? (countedPrice += priceDiff / 10)
										: (countedPrice -= priceDiff / 10);
								} else {
									countedPrice = 0;
								}
								price.text(Number(countedPrice).toFixed(2));
							} else {
								newPrice == 0 ? price.text("0.00") : price.text(newPrice);
								clearInterval(countingInterval);
								counting = 0;
							}
						}
					}, 10);
				}

				function handleQuantityChange() {
					quantity.val(parseInt(quantity.val()));
					var val = quantity.val();
					val == "" && quantity.val(0);
					val > 99999999 && quantity.val(99999999);
					val < 0 && quantity.val(0);
					if (val.length > 1 && val[0] == 0) {
						quantity.val(val.replace(/^0+/, ""));
					}
					SMSquantity = quantity.val();

					calculatePrice();
				}

				$("body").on("click", function (e) {
					selectionListActive() &&
						!$(e.target).hasClass("selection-list__arrow") &&
						(function () {
							!!$(e.target).closest("#pricingSelectionList").find(e.target)
								.length || selectionListAction("hide");
						})();
				});

				selectionArrow.on("click", function () {
					selectionListActive()
						? selectionListAction("hide")
						: selectionListAction("show");
				});

				selectionList.on("click", function (e) {
					e.target.nodeName === "INPUT" &&
						(function () {
							selectedFilters = selectionList.find(":checked").length;
							var plural = selectedFilters === 1 ? "" : "s";
							var filterText = "filter";
							if (document.documentElement.lang.toLowerCase() == "en") {
								filterText = "filter" + plural;
							} else if (document.documentElement.lang.toLowerCase() == "ar") {
								filterText = "خيارات الفرز";
							}
							selectionCounter.text(selectedFilters + " " + filterText);
							calculatePrice();
						})();
				});

				quantity.on("change input", function () {
					handleQuantityChange();
				});

				quantity.on("keypress", function (e) {
					var regex = new RegExp("^[0-9]+$");
					var key = String.fromCharCode(!e.charCode ? e.which : e.charCode);
					if (!regex.test(key)) {
						e.preventDefault();
						return false;
					}
				});
			})();
	})();

	var counter = function () {
		// hours
		// 8:00 - 480
		// 9:00 - 540
		// 12:30 - 750
		// 13:00 - 780
		// 17:40 - 1060
		// 20:00 - 1200
		// 22:15 - 1335
		// 00:00 - 1440
		var timer = $(".time-counter__hours-js");
		var counterGif = $(".time-counter__ten-gif");
		var currentTime = 540;
		var counter = 0;
		var stops = [540, 750, 780, 1060, 1200, 1335, 1980];
		pauseTime = 70;
		tripTime = 30;
		var step = 0;

		function calculate(value) {
			var value = Math.floor(value);
			var h = Math.floor(value / 60);
			var m = value - h * 60;
			h = h % 24;
			if (h < 10) {
				h = "0" + h;
			} else if (h == 24) {
				h = "00";
			}
			if (m < 10) {
				m = "0" + m;
			}
			return h + ":" + m;
		}

		var knowMoreAnimationInterval = setInterval(function () {
			//begining of a cycle
			if (counter == 0) {
				$(".ellipse-device .text-container > div").each(function () {
					$(this).hide();
				});
				$(".ellipse-device__text--" + (step + 1)).show();
				$(".ellipse-clock .place--" + step).removeClass("text-roll");
				$(".ellipse-clock .place--" + (step + 1)).addClass("text-roll");
				$(".ellipse-device .text-container").addClass("grow-in");
				counterGif.hide();
				currentTime = stops[step];
				timer.html(calculate(currentTime));
			}
			//after pause
			else if (counter == pauseTime) {
				$(".ellipse-device .text-container").removeClass("grow-in");
				$(".ellipse-clock .clock-container").addClass("step--" + (step + 1));
				$(".ellipse-device_point").addClass("step--" + (step + 1));
				counterGif.show();
			}
			//trip period
			else if (counter > pauseTime && counter < pauseTime + tripTime) {
				timer.html(calculate(currentTime));
				var range = stops[step + 1] - stops[step];
				currentTime += range / tripTime;
			}
			//end of cycle
			else if (counter >= pauseTime + tripTime) {
				step++;
				counter = -1;
			}
			counter++;

			//reset animation
			if (currentTime >= stops[stops.length - 1]) {
				for (var i = 1; i <= step; i++) {
					$(".ellipse-clock .clock-container").removeClass("step--" + i);
					$(".ellipse-device_point").removeClass("step--" + i);
					$(".ellipse-clock .place--" + i).removeClass("text-roll");
				}
				currentTime = 540;
				counter = 0;
				step = 0;
			}
		}, 100);
	};
	$(document).ready(function () {
		if ($(".ellipse-clock").length) {
			document.addEventListener("scroll", ellipseFloat);
			counter();
		}
	});

	visibilityAction("percentage", 0, "animated");
	visibilityAction("percentage", 1, "animated");
	visibilityAction("percentage", 1, "animated");
	visibilityAction("clickable-text__letter", 1, "clickAction");
	visibilityAction("graph--analytics", 0, "animated", 50, false);
	visibilityAction("graph--targeting", 0, "animated", 50, false);
	visibilityAction("graph--digital", 0, "animated", 50, false);
	clickableLetters.autoStart();

	$(".slider").slick({
		dots: false,
		infinite: true,
		speed: 300,
		slidesToShow: 1,
		adaptiveHeight: true,
		prevArrow: '<span class="slider__arrow--prev"></span>',
		nextArrow: '<span class="slider__arrow--next"></span>'
	});

	$(document).on("scroll", function (event) {
		console.log("scroll");
		if (benefits.allowEventListener) {
			var fixedImage = benefits.fixedImage;
			benefits.allowEventListener = false;

			setTimeout(function () {
				if (currentPosition() > fixedImage.bottomPosition()) {
					fixedImage.unFix();
					fixedImage.select.css({ bottom: fixedImage.bottomHeight() });
				} else {
					fixedImage.fix();
					fixedImage.select.css({ bottom: 0 });
				}
				benefits.allowEventListener = true;
			}, 50);
		}
	});

	var footerTextArea = {
		element: $("#contact-us-textarea"),
		currentLength: $("#contact-us-curent"),
		submitButton: $("#contact-us-submit"),
		scrollDown: function () {
			footerTextArea.element.addClass("active");
		},
		scrollUp: function () {
			footerTextArea.element.removeClass("active");
		}
	};

	footerTextArea.element.on("focus touchstart", function () {
		if (!footerTextArea.element.hasClass("active")) {
			footerTextArea.scrollDown();
		}
	});

	footerTextArea.element.on("blur", function (event) {
		if (footerTextArea.element.val().length < 1) {
			footerTextArea.scrollUp();
		}
	});

	footerTextArea.element.on("input", function () {
		footerTextArea.currentLength.text(footerTextArea.element.val().length);
		if (
			footerTextArea.element.val().length ==
			footerTextArea.element.attr("maxlength")
		) {
			footerTextArea.currentLength.css({ color: "#ff314e" });
		} else {
			footerTextArea.currentLength.css({ color: "#27bbc2" });
		}
	});

	footerTextArea.submitButton.on("click touchend", function (event) {
		if (
			$(".footer__form").find(".error").length > 0 ||
			$(".form__input").val().length == 0
		) {
			event.preventDefault();
		}
	});

	benefits.pointText.init();

	$(".navigator__link").on("click", function () {
		if ($(this).attr("data-navigator-to")) {
			var scrollTo =
				$("#" + $(this).attr("data-navigator-to")).offset().top - 80;
			$("html, body").animate(
				{
					scrollTop: scrollTo
				},
				500
			);
		}
	});
	function runVideo() {
		$("#video-placeholder").on("click", function () {
			$(this).hide();
			$("#yt-video")[0].src += "&autoplay=1";
			setTimeout(function () {
				$("#yt-video").show();
			}, 200);
		});
	}

	function setLanguageCookie() {
		if (!Cookies.get("tl_lang")) {
			Cookies.set("tl_lang", $("html").attr("lang"), { expires: 365 * 10 });
		}
		Weglot.on("languageChanged", function (newLang, prevLang) {
			Cookies.set("tl_lang", newLang, { expires: 365 * 10 });
		});
	}

	function reloadHPLettersLanguage() {
		Weglot.on("languageChanged", function (newLang, prevLang) {
			var activeLetter = $(".clickable-text__letter--selected");
			$(".clickable-text__letter")
				.not(".clickable-text__letter--selected")[1]
				.click();
			activeLetter.click();
		});
	}

	function showVatBanner() {
		$(".vat-container .closeit").on("click", function () {
			Cookies.set("vat_banner_seen", true, { expires: 365 * 10 });
			$(".vat-container").slideUp();
		});
		if (!Cookies.get("vat_banner_seen")) {
			$(".vat-container").css("display", "block");
		}
	}

	$(document).ready(function () {
		setLanguageCookie();
		reloadHPLettersLanguage();
		runVideo();
		showVatBanner();
	});

	window.apiPath =
		window.location.hostname.indexOf("localhost") > -1
			? "http://localhost:8080/"
			: window.location.protocol + "//" + window.location.hostname + "/";
	window.isStageEnv = window.location.hostname.indexOf("stg") > -1;
}

function getUrlParameters() {
	var parameters = {},
		hash;
	var hashes = window.location.href
		.slice(window.location.href.indexOf("?") + 1)
		.split("&");
	for (var i = 0; i < hashes.length; i++) {
		hash = hashes[i].split("=");
		parameters[hash[0]] = hash[1];
	}
	return parameters;
}

function hasBeenReachedWithDepth(elem, depth) {
	var bounding = elem.getBoundingClientRect();
	return document.documentElement.clientHeight - bounding.top - depth >= 0;
}

function ellipseFloat() {
	if (
		hasBeenReachedWithDepth(
			document.getElementById("boxBenefits"),
			window.innerHeight - $("#ellipse-container").outerHeight() - 230
		)
	) {
		$(".ellipse-container").removeClass("floating").addClass("stick");
	} else {
		$(".ellipse-container").addClass("floating").removeClass("stick");
	}
}
